import { render, staticRenderFns } from "./useAgreement.vue?vue&type=template&id=9ad4fe20&scoped=true&"
import script from "./useAgreement.vue?vue&type=script&lang=js&"
export * from "./useAgreement.vue?vue&type=script&lang=js&"
import style0 from "./useAgreement.vue?vue&type=style&index=0&id=9ad4fe20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad4fe20",
  null
  
)

export default component.exports